import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { EASE_OUT_EXPO } from "../../lib/motion";

/**
 * Masked line-by-line reveal for headlines. Splits `text` on \n and wraps
 * each line inside an overflow-hidden container. Uses `useInView` to detect
 * visibility and animates immediately on mount if already visible.
 */
export default function RevealText({
  text,
  as: Tag = "h1",
  className = "",
  delay = 0,
  stagger = 0.09,
  testId,
  duration = 0.9,
}) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.05 });
  const lines = text.split("\n");
  return (
    <Tag ref={ref} className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            initial={{ y: "110%", opacity: 0 }}
            animate={inView ? { y: "0%", opacity: 1 } : { y: "110%", opacity: 0 }}
            transition={{
              duration,
              ease: EASE_OUT_EXPO,
              delay: delay + i * stagger,
            }}
            className="block will-change-transform"
          >
            {line || "\u00A0"}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
